import { notification } from 'antd';
import axios from 'axios';
import base64 from 'base-64';

import { SIGNIN_INIT, SET_ACCOUNT } from '../_types';
import { hp, cw } from '../../utils';
import { deleteCookie } from '../../utils/helpers';

const getActiveAccount = (user , accounts) => {
    let activeAccount = accounts.length === 1 ? accounts[0] : (user.preferences || {}).active_account || accounts[0];
    if (accounts.filter(row => row.id === activeAccount.id)[0] === undefined) {
        activeAccount = {};
    }
    if (activeAccount.id) {
        activeAccount = accounts.filter(row => row.id === activeAccount.id)[0];
        activeAccount['logo_url'] = activeAccount['logo_url'] || activeAccount['logo'];
    }
    return activeAccount
}

export const setLoginStorage = (user, account, activeAccount) => {
    let oldUser = hp.getCookie('user') || {};
    let ssoUser = {
        user_id: user.id,
        first_name: user.firstName,
        last_name: user.lastName,
        email: user.email,
        msisdn: user.msisdn,
        account_id: activeAccount.id,
        role: user.role,
        user_preferences: user.preferences || {},
        status: user.status,
        signup_country: user.country && user.country !== 'undefined' ? user.country : 'Ghana',
        profile_image: user.profileImage || user.profileImageUrl || oldUser.profile_image
    };
    account['accountId'] = account.id;
    hp.setCookie('user', JSON.stringify(ssoUser), 7);
    hp.setCookie('account', JSON.stringify(account), 7);
    hp.setCookie('user_id', ssoUser.user_id);
    hp.setCookie('user_name', ssoUser.first_name);
    hp.setCookie('active_account', JSON.stringify(activeAccount));
    hp.setCookie('project_id', ssoUser.account_id);
    return ssoUser;
}

export const afterLogin = (lang, intl, dispatch, token, user, account, onOK, onOkData) => {
    axios({
        method: 'GET',
        url: `${hp.getApiBaseUrl()}/users/${user.id.trim()}/accounts`,
        headers: { 'x-access-token': token },
    }).then((response) => {
        const res = response.data;
        if (res.statusCode === 200) {
            const activeAccount = getActiveAccount(user , res.data)
            setLoginStorage(user, account, activeAccount);
            hp.setCookie('user_token', token, 7);
            if (res.data.length > 0) {
                if (activeAccount.id) {
                    accountLogin(activeAccount.id , user.id).then(res => {
                        const {accountToken , userRole} = res;
                        hp.setCookie('user_token', accountToken);
                        setLoginStorage({
                            ...user ,
                            role : userRole ,
                        }, account, activeAccount);
                        if (onOK) {
                            onOK(onOkData);
                        } else {
                            window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                        }
                    }).catch(e => {
                        dispatch({ type: SIGNIN_INIT, payload: false });
                        notification.error({ message: intl.formatMessage(cw['Error.Default']) });
                    })
                } else {
                    window.location.assign(`/${lang || 'en'}/choose-account`);
                }
            } else {
                window.location.assign(`/${lang || 'en'}/create-account`);
            }
        }
    }).catch((err) => {
        dispatch({ type: SIGNIN_INIT, payload: false });
        const res = JSON.parse((err.request || '').response);
        notification.error({
            message: intl.formatMessage(cw.signInFailed),
            description: res.message
        });
    });
}

export function signIn(intl, lang, data, onOK) {
    return dispatch => {
        dispatch({ type: SIGNIN_INIT, payload: true });
        axios({
            method: 'POST',
            url: `${hp.getApiBaseUrl()}/auth/logins`,
            headers: {
                Authorization: `Basic ${base64.encode(data.email + ':' + data.password)}`
            }
        }).then((response) => {
            const res = response.data;
            if (res.statusCode === 200) {
                let user = res.data.user;
                let token = res.token;
                let onOkData = res.data;
                let account = res.data.account;
                afterLogin(lang, intl, dispatch, token, user, account, onOK, onOkData);
            } else {
                dispatch({ type: SIGNIN_INIT, payload: false });
                notification.error({
                    message: intl.formatMessage(cw.signInFailed),
                    description: intl.formatMessage(cw.signInFailedDesc)
                });
            }
        }).catch((err) => {
            dispatch({ type: SIGNIN_INIT, payload: false });
            notification.error({
                message: intl.formatMessage(cw.signInFailed),
                description: intl.formatMessage(cw.signInFailedDesc)
            });
        });
    }
};


export function signUp(intl, lang, data, onOK) {
    return dispatch => {
        dispatch({ type: SIGNIN_INIT, payload: true });
        axios({
            method: 'POST',
            url: `${hp.getApiBaseUrl()}/auth/signups`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Basic ${base64.encode(data.email + ':' + data.password)}`
            },
            data
        }).then((response) => {
            dispatch({ type: SIGNIN_INIT, payload: false });
            const res = response.data;
            if (res.statusCode === 200) {
                let user = res.data.user;
                let token = res.token;
                let onOkData = res.data;
                let account = res.data.account;
                deleteCookie('promoCode', true);
                afterLogin(lang, intl, dispatch, token, user, account, onOK, onOkData);
            } else {
                notification.error({
                    message: 'Signup Failed',
                    description: intl.formatMessage(cw.signUpFailed)
                });
            }
        }).catch((err) => {
            dispatch({ type: SIGNIN_INIT, payload: false });
            notification.error({
                message: 'Signup Failed',
                description: intl.formatMessage(cw.signUpFailed)
            });
        });
    }
};

export function setAccount(data) {
    return dispatch => {
        dispatch({ type: SET_ACCOUNT, data });
    }
};


export function signOut() {
    return dispatch => {
        hp.deleteCookie('user');
        hp.deleteCookie('user_token');
        hp.deleteCookie('user_id');
        hp.deleteCookie('account');
        hp.deleteCookie('project_id');
        hp.deleteCookie('active_account');
        window.location = (`/en/signin`);
        // window.location.assign(`/en/signin${window.location.search}`);
        // dispatch({ type: SIGNOUT_SUCCESS });
    }
};


export function accountLogin(accountId, userId) {
    return Promise.all([
      axios({
        method: "POST",
        url: `${hp.getApiBaseUrl()}/auth/account-logins`,
        headers: { "x-access-token": hp.getCookie("user_token") },
        data: {
          accountId,
          userId,
        },
      }),
      axios({
        method: "GET",
        url: `${hp.getApiBaseUrl()}/user-accounts/${userId}/${accountId}`,
        headers: { "x-access-token": hp.getCookie("user_token") },
      }),
    ])
      .then((res) => {
          const accountLoginsRes = res[0].data;
          const userRoleRes = res[1].data;
          if (
              accountLoginsRes.statusCode === 200 &&
              userRoleRes.statusCode === 200
            ){
               return { accountToken : accountLoginsRes.token , userRole : userRoleRes.data.role}
            }
            throw Error('Unable to switch account')
      })
      .catch((e) => {
        throw e;
      });
  }
